import { render, staticRenderFns } from "./SeeFriends.vue?vue&type=template&id=2c991248&"
import script from "./SeeFriends.vue?vue&type=script&lang=js&"
export * from "./SeeFriends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports